import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { UploadedFile } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetUploadFiles = (matterId: string, uploadId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UploadedFile[]>(
    [QueryEntity.UploadFiles, matterId, uploadId],
    () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/upload-history/${uploadId}/files`, fetchConfigGET).then(
        (res) => {
          return res.json();
        },
      );
    },
    {
      enabled: !!matterId && !!uploadId,
      refetchOnWindowFocus: false,
    },
  );
};
